module.exports = __webpack_public_path__ + "img/juntas_aparentes.6ae9ad0f.png";